import { CascaderField, Col } from '@/components';
import { PS_MAX_CASCADER_SELECTION } from '@/features/project/_utils/constants';
import { useGetReferenceFiscalYearBySearchType } from '@/features/search/_hooks/projects-search';
import type { SharedSearchFormType } from '@/features/search/_models/shared-search';
import {
  COL_MIN_WIDTH,
  handleCascaderOnChange,
} from '@/features/search/_utils/projects-search';
import { useOrganizationOptionsRecursive } from '@/features/tenant-manager/organization/_hooks/organization';
import { useMessage } from '@/providers';
import { isPS } from '@/utils';
import { type FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const NestedOtherResponsibleOrganizationIdsColField: FC = memo(() => {
  const { t } = useTranslation();
  const { openMessage } = useMessage();

  const {
    control: sharedSearchControl,
    formState: { errors },
    setValue: setSharedSearchValue,
  } = useFormContext<SharedSearchFormType>();

  const referenceFiscalYear = useGetReferenceFiscalYearBySearchType();

  const organizationsOptions = useOrganizationOptionsRecursive({
    params: { referenceFiscalYear: referenceFiscalYear?.toString() },
  });

  return (
    <Col span={8} style={{ minWidth: COL_MIN_WIDTH.large }}>
      <CascaderField
        name="nestedOtherResponsibleOrganizationIds"
        label={t('other-organization-in-charge')}
        control={sharedSearchControl}
        options={organizationsOptions.data}
        loading={organizationsOptions.isPending}
        multiple
        errors={errors}
        hint={
          isPS()
            ? t('hint-other-organization-in-charge-cascader-selection', {
                limit: PS_MAX_CASCADER_SELECTION,
              })
            : t('hint-search-other-organization-in-charge')
        }
        onChange={(value) => {
          handleCascaderOnChange(
            'nestedOtherResponsibleOrganizationIds',
            value?.map((v) => v.map((v) => v.toString())) ?? [],
            setSharedSearchValue,
            openMessage,
          );
        }}
      />
    </Col>
  );
});
